/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as KeysRouteImport } from './routes/keys'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as ChooseRouteImport } from './routes/choose'
import { Route as IndexRouteImport } from './routes/index'

const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const KeysRoute = KeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const ChooseRoute = ChooseRouteImport.update({
  id: '/choose',
  path: '/choose',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/choose': typeof ChooseRoute
  '/connect': typeof ConnectRoute
  '/keys': typeof KeysRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/usage': typeof UsageRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/choose': typeof ChooseRoute
  '/connect': typeof ConnectRoute
  '/keys': typeof KeysRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/usage': typeof UsageRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/choose': typeof ChooseRoute
  '/connect': typeof ConnectRoute
  '/keys': typeof KeysRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/usage': typeof UsageRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/choose' | '/connect' | '/keys' | '/unauthorized' | '/usage'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/choose' | '/connect' | '/keys' | '/unauthorized' | '/usage'
  id:
    | '__root__'
    | '/'
    | '/choose'
    | '/connect'
    | '/keys'
    | '/unauthorized'
    | '/usage'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ChooseRoute: typeof ChooseRoute
  ConnectRoute: typeof ConnectRoute
  KeysRoute: typeof KeysRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  UsageRoute: typeof UsageRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/keys': {
      id: '/keys'
      path: '/keys'
      fullPath: '/keys'
      preLoaderRoute: typeof KeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/choose': {
      id: '/choose'
      path: '/choose'
      fullPath: '/choose'
      preLoaderRoute: typeof ChooseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ChooseRoute: ChooseRoute,
  ConnectRoute: ConnectRoute,
  KeysRoute: KeysRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  UsageRoute: UsageRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
